import React from 'react';

import config from '../utility/config';

export default class Login extends React.Component {


    constructor(props) {
        super(props);
        this.state = { loggedIn: false, idToken: '' };
        this.prepare = this.prepare.bind(this);
        this.prepare();

    }

    parseUserInfo(Token) {

        // parts of idToken HEADER.PAYLOAD.SIGNATURE
        const parts = Token.split('.');
        let stringPayLoad = undefined;
        const payLoad = JSON.parse(stringPayLoad = atob(parts[1]));
        console.log(payLoad);
        localStorage.setItem('user', stringPayLoad);
        this.state.loggedIn = true;


    }

    prepare() {
        console.log("............preparaing.............");
        const search = window.location.search;
        const idToken = new URLSearchParams(search).get('idToken');
        localStorage.setItem('idToken', idToken);
        this.parseUserInfo(idToken)
        console.log(idToken);
    }

    render() {
        if (this.state.loggedIn === true) {
            window.location.href = config.homeLink;
        }
        return (
            <>
            </>

        );
    }

}